import $ from "jquery";
$('.cu-part__expanders.accordion .expander .expander-header').on('click', function(e) {
    e.preventDefault();

    $(this).toggleClass('active').parent().find('.expander-body').slideToggle(400);
});

$('.cu-part__expanders.tabs .expander .expander-header').on('click', function(e) {
    e.preventDefault();
    var thisID = $(this).parent().attr('id');
    $(this).parent().siblings().not($(this).parent().attr('id')).find('.expander-header.active').toggleClass('active').parent().find('.expander-body').slideUp();
    $(this).toggleClass('active').parent().find('.expander-body').slideToggle(400);
    console.log(thisID);
    $('.tablinks').removeClass("tabhighlight");
    $("#btn-" + thisID).addClass("tabhighlight");

});

$('.tablinks').on('click', function(e) {
    e.preventDefault();
    var tabbtnID = $(this).attr('id');
    var targetID = tabbtnID.slice(4);
    var tabsID = $(this).attr('tabsid');
    
    if (jQuery ('#'+ targetID + ' .expander-header').hasClass('active')){console.log ("Active");

    } else {

  jQuery('.'+tabsID+'.expander-header.active').not('#' + targetID +' .expander-header').toggleClass('active').parent().find('.expander-body').slideUp();
  jQuery('#' + targetID +' .expander-header').toggleClass('active').parent().find('.expander-body').slideToggle(400);
  $('.tablinks.' + tabsID ).removeClass("tabhighlight");
  $(this).addClass("tabhighlight");
    }
});


$(document).ready(function(){
  $('.firsttab .expander-header').toggleClass('active').parent().find('.expander-body').slideToggle(400);
  $('.firsttabbutton').addClass("tabhighlight");
});


/* Internal expanders */
$(document).on('click', '.expander-body .copy .intexpander', function(e) {
  e.preventDefault();

  var $header = $(this);
  var $content = $header.next('.intcontent');

  if (!$content.length) return;

  var isLast = !$content.next('.intexpander').length;
  var isOpen = $header.hasClass('active');

  if (isOpen) {
    $header.removeClass('active');

    $content.stop(true, true).slideUp(300, function() {
      if (isLast) {
        $header.addClass('is-closed-last');
      }
      $header.attr('aria-expanded', 'false');
    });

  } else {
    if (isLast) {
      $header.removeClass('is-closed-last');
    }

    $header.addClass('active');
    $header.attr('aria-expanded', 'true');
    $content.stop(true, true).slideDown(300);
  }
});

$(document).on('keydown', '.expander-body .copy .intexpander', function(e) {
  if (e.key === 'Enter' || e.key === ' ') {
    e.preventDefault();
    $(this).trigger('click');
  }
});

$(document).ready(function() {
  $('.expander-body .copy .intexpander').each(function(index) {
    var $header = $(this);
    var $content = $header.next('.intcontent');

    if (!$content.length) return;

    if (!$header.attr('id')) {
      $header.attr('id', 'intexpander-' + index);
    }

    if (!$content.attr('id')) {
      $content.attr('id', 'intcontent-' + index);
    }

    $header.attr({
      role: 'button',
      tabindex: '0',
      'aria-controls': $content.attr('id'),
      'aria-expanded': 'false'
    });

    // Add bottom border ONLY to last collapsed item
    var isLast = !$content.next('.intexpander').length;
    if (isLast) {
      $header.addClass('is-closed-last');
    }
  });
});












      


